export default __webpack_public_path__ + "static/media/landRover.0adbbca4.webp";